import AuditField from "./AuditField";

export default function BlocPersoObjectifs({ data }) {
  const p = data.projets || {};
  const o = data.objectifs || [];

  return (
    <section className="space-y-6 bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl font-bold text-gray-800">Objectifs & Profil</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <AuditField label="Enveloppe à investir" value={data.enveloppe + ' €'} />
        <AuditField label="Besoins exprimés" value={data.besoins} />
        <AuditField label="Commentaire interne" value={data.commentaire} />
        <AuditField label="Épargne mensuelle" value={data.epargneMensuelle + ' €'} />
        <AuditField label="Revenu net mensuel" value={data.revenuNetMensuel + ' €'} />
        <AuditField label="Taux d’endettement" value={data.tauxEndettement + ' %'} />
      </div>

      <h3 className="text-lg font-semibold text-gray-700">Objectifs exprimés</h3>
      <AuditField label="Liste des objectifs" value={o.length ? o.join(", ") : "—"} />

      <h3 className="text-lg font-semibold text-gray-700">Projets</h3>
      <AuditField label="Projets personnels" value={p.personnel?.join(', ') || "—"} />
      <AuditField label="Projets professionnels" value={p.professionnel?.join(', ') || "—"} />

      <h3 className="text-lg font-semibold text-gray-700">Profil & Connaissances</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <AuditField label="Connaissances financières" value={data.connaissancesFinancieres} />
        <AuditField label="Connaissances juridiques & fiscales" value={data.connaissancesJuridiquesFiscales} />
        <AuditField label="Appétence au risque" value={data.appetenceRisque} />
      </div>
    </section>
  );
}
